export const dependentSexOptions = [
	{label: 'Male', value: 'M'},
	{label: 'Female', value: 'F'},
	{label: 'Unspecified', value: 'U'},
] as const;

export type DependentSex = (typeof dependentSexOptions)[number]['value'];

export const normalizeDependentSex = (value?: string | null): DependentSex => {
	const normalized = value?.trim().toUpperCase();

	if (!normalized) {
		return 'U';
	}

	if (['M', 'MALE'].includes(normalized)) {
		return 'M';
	}

	if (['F', 'FEMALE'].includes(normalized)) {
		return 'F';
	}

	return 'U';
};

export type Dependent = {
	id?: number;
	first_name: string;
	last_name: string;
	date_of_birth: string;
	email?: string;
	cell_phone?: string;
	sex?: string;
	gender?: string;
	is_coverage_attested?: boolean;
};
